/**
 * ============================================
 * DOF Inc. Website - Main JavaScript
 * ============================================
 * BUILD TEST: v2.1 - 2025-12-09 22:41
 * 
 * 行数: 3,185行
 * コード: 100%カスタム（外部ライブラリなし）
 * 
 * 依存ライブラリ（別ファイル）:
 * - GSAP/TweenMax (libs.js)
 * - Vimeo Player (外部CDN)
 * - Google Maps API (外部CDN)
 * 
 * 主要コンポーネント:
 * - GNS Framework (カスタムクラスシステム)
 * - SceneController (ページ管理)
 * - Header/Navigation (ヘッダー・メニュー)
 * - Language Switch (言語切り替え)
 * 
 * ============================================
 */

"use strict";

// ============================================
// グローバル名前空間の初期化
// ============================================

import { GNS } from '../core/GNS.js';






// ============================================
// CookieManager - Cookie管理システム
// ============================================

/**
 * GNS.CookieManager
 * 
 * Cookieの読み書きを管理
 * 
 * 主要メソッド:
 * - getKey(key): Cookieから値を取得
 * - setKey(key, value, days, path): Cookieに値を保存
 * 
 * 使用例:
 * CookieManager.setKey("lang", "ja", 365);
 * var lang = CookieManager.getKey("lang");
 */
GNS.CookieManager = function (a) {
  var b = a.create(),
    c = new Date;

  /**
   * getKey(key) - Cookie取得
   * 
   * @param {string} key - Cookie名
   * @returns {string|null} - Cookie値、存在しない場合はnull
   */
  return b._static.getKey = function (a) {
    if (document.cookie.length <= 0) return null;
    for (var b = document.cookie.split("; "), c = null, d = 0; d < b.length; d++) {
      var e = b[d].split("=");
      if (e[0] == a) {
        c = e[1];
        break
      }
    }
    return c
  }, b._static.setKey = function (a, b, d, e) {
    d || (d = 365), c.setTime(c.getTime() + 864e5 * d), e ? document.cookie = a + "=" + (null != b ? escape(b) :
      "") + "; path=" + e + ";  expires=" + (null != b ? c.toGMTString() : new Date("1999-12-31T23:59:59Z")
        .toGMTString()) : document.cookie = a + "=" + (null != b ? escape(b) : "") + "; path=/;  expires=" + (
          null != b ? c.toGMTString() : new Date("1999-12-31T23:59:59Z")
            .toGMTString())
  }, b._self
}(GNS);

// ============================================
// OrientationManager - デバイス向き管理
// ============================================

/**
 * GNS.OrientationManager
 * 
 * デバイスの向き（縦/横）を検出・管理
 * 
 * 定数:
 * - ORIENTATION_PORTRAIT: 縦向き
 * - ORIENTATION_LANDSCAPE: 横向き
 * 
 * 主要メソッド:
 * - init(): 初期化、orientationchangeイベントを監視
 * - check(): 現在の向きをチェック
 * - addEventListener(callback): 向き変更イベントリスナー追加
 */
GNS.OrientationManager = function (a) {
  var b = a.create();
  b._static.ORIENTATION_PORTRAIT = "portrait", b._static.ORIENTATION_LANDSCAPE = "landscape", b._static.screenHeight =
    0, a.orientation = b._static.ORIENTATION_PORTRAIT;
  var c, d = !1;
  return b._static.init = function () {
    d || (c = new a.EventThrottle(1e3 / 24), a.DOM.addEvent(window, "orientationchange", b._static.change), b
      ._static.check(), d = !0)
  }, b._static.addEventListener = function (a) {
    return c && a && "function" == typeof a ? void c.addEventListener(a) : !1
  }, b._static.removeEventListener = function (a) {
    return c && a && "function" == typeof a ? void c.removeEventListener(a) : !1
  }, b._static.check = function () {
    switch (window.orientation) {
      case -90:
      case 90:
        a.orientation = b._static.ORIENTATION_LANDSCAPE, b._static.screenHeight = Math.max(window.screen.width, window
          .screen.height);
        break;
      default:
        var c = a.DOM.getPageSize();
        a.isSP ? a.orientation = b._static.ORIENTATION_PORTRAIT : a.isPC && c.displayWidth > c.displayHeight ? a
          .orientation = b._static.ORIENTATION_LANDSCAPE : a.orientation = b._static.ORIENTATION_PORTRAIT, b._static
            .screenHeight = Math.max(window.screen.width, window.screen.height)
    }
  }, b._static.change = function () {
    b._static.check(), c.dispatchEvent()
  }, b._static.choice = function (c, d) {
    return a.orientation == b._static.ORIENTATION_PORTRAIT ? c : d
  }, b._self
}(GNS);

// ============================================
// ResizeManager - リサイズ管理
// ============================================

/**
 * GNS.ResizeManager
 * 
 * ウィンドウリサイズイベントを管理
 * EventThrottleを使用してパフォーマンスを最適化
 * 
 * 主要メソッド:
 * - init(callback): 初期化
 * - addEventListener(callback): リサイズイベントリスナー追加
 * - removeEventListener(callback): リサイズイベントリスナー削除
 */
GNS.ResizeManager = function (a) {
  var b, c = a.create(),
    d = !1,
    e = null;
  c._static.init = function (f) {
    d || (f && (e = f), b = new a.EventThrottle(1e3 / 24), a.DOM.addEvent(window, a.Event.RESIZE, c._static.resize),
      d = !0)
  }, c._static.addEventListener = function (a) {
    return b && a && "function" == typeof a ? void b.addEventListener(a) : !1
  }, c._static.removeEventListener = function (a) {
    return b && a && "function" == typeof a ? void b.removeEventListener(a) : !1
  }, c._static.resize = function () {
    e && e(), b.dispatchEvent()
  };
  return c._self
}(GNS);
// ============================================
// Animate - アニメーションシステム
// ============================================
/**
 * GNS.Animate
 * 
 * カスタムアニメーションエンジン
 * CSSプロパティをアニメーションさせる
 * 
 * 主要メソッド:
 * - to(element, duration, params): アニメーション実行
 * - direct(element, params): 即座にプロパティ設定
 * - kill(element): アニメーション停止
 * 
 * イージング関数:
 * - linear, easeInQuad, easeOutQuad
 * - easeInCubic, easeOutCubic
 * - easeInQuart, easeOutQuart
 * など多数
 */
GNS.Animate = function (a) {
  var b = a.create();
  b._static.BROWSER_PERFIX;
  var c = 30;
  b._static.to = function (a, c, f) {
    if (!a) return !1;
    c || (c = 0), f || (f = {});
    for (var i = new k(a, c, f), j = d.length - 1; j >= 0; j--) d[j]._target == a && (i._update = !0);
    d.push(i), d.length >= 1 && !e && (e = !0, g = Date.now(), h(b._static.render))
  }, b._static.allTo = function (a, c, d) {
    if (!a || 0 == a.length) return !1;
    for (var e = 0; e < a.length; e++) b._static.to(a[e], c, d)
  }, b._static.directTo = function (a, c, d, e) {
    return a ? (c || (c = 0), d || (d = {}), e || (e = {}), b._static.kill(a), b._static.direct(a, d), void b
      ._static.to(a, c, e)) : !1
  }, b._static.kill = function (a) {
    if (!a) return !1;
    for (var b = d.length - 1; b >= 0; b--) d[b]._target == a && (d[b]._forcekill = !0)
  }, b._static.direct = function (a, b) {
    for (var c in b) l(a, c, b[c])
  }, b._static.allDirect = function (a, c) {
    if (!a || 0 == a.length) return !1;
    for (var d = 0; d < a.length; d++) b._static.direct(a[d], c)
  }, b._static.addRender = function (a, c) {
    var f = {};
    f.onUpdate = a, f.isContinue = !0, c || (c = window);
    var i = new k(c, 0, f);
    d.push(i), d.length >= 1 && !e && (e = !0, g = Date.now(), h(b._static.render))
  }, b._static.removeRender = function (a, b) {
    for (var c = d.length - 1; c >= 0; c--) d[c]._onUpdate == a && d[c]._target == b && (d[c]._isContinue = !1)
  }, b._static.render = function () {
    var a = (new Date)
      .getTime(),
      c = a - g;
    c > f && (g = a - c % f, j()), 0 == d.length && e ? e = !1 : (e = !0, h(b._static.render))
  }, b._static.getUnitAdjust = function (a) {
    return String(a)
      .length >= 3 ? (-1 != String(a)
        .indexOf("px") && (a = String(a)
          .replace("px", "")), parseInt(a)) : null != a && "" != a ? parseInt(a) : 0
  }, b._static.setUnitAdjust = function (a) {
    return -1 != String(a)
      .indexOf("px") ? a : null != a && "" != a ? a + "px" : "0px"
  }, b._static.getStat = function () {
    return e
  }, b._static.searchBrowserPrefix = function () {
    for (var a = ["requestAnimationFrame", "webkitRequestAnimationFrame", "MozRequestAnimationFrame",
      "oRequestAnimationFrame", "msRequestAnimationFrame"], b = 0; b < a.length; b++)
      if (window && a[b] in window) return a[b];
    return null
  };
  var d = [],
    e = !1,
    f = 1e3 / c,
    g = 0,
    h = function () {
      return b._static.BROWSER_PERFIX || (b._static.BROWSER_PERFIX = b._static.searchBrowserPrefix()), window[b
        ._static.BROWSER_PERFIX] || function (a, c) {
          window.setTimeout(b._static.render, f)
        }
    }(),
    j = function () {
      for (var a = (new Date)
        .getTime(), c = d.length - 1; c >= 0; c--) {
        var e = d[c],
          f = !1;
        if (a >= e._endTime && (f = !0), e._isContinue && (f = !1), e._forcekill) d.splice(c, 1), e = null;
        else if (a >= e._delay) {
          null != e._onStart && (e._onStart.apply(e._target, e._onStartParams || []), e._onStart = null, e
            ._onStartParams = null), e._update && (e.update(), e._update = !1);
          for (var g in e._sparams) {
            var h = a - e._delay,
              i = e._endTime - e._delay,
              j = e._sparams[g],
              k = e._params[g] - e._sparams[g],
              n = 0;
            if (n = h >= i ? k + j : e._ease ? e._ease(h, j, k, i) : b._static.linear(h, j, k, i), e._bezier &&
              "bezierTime" == g) {
              var o = m(e._bezier, n);
              l(e._target, "left", o.x), l(e._target, "top", o.y)
            } else l(e._target, g, n)
          }
          f ? (d.splice(c, 1), null != e._onComplete && e._onComplete.apply(e._target, e._onCompleteParams || []), e =
            null) : null != e._onUpdate && e._onUpdate.apply(e._target, e._onUpdateParams || [])
        }
      }
    },
    k = function (a, b, c) {
      this._target = a, this._duration = b, this._params = c, this._sparams = {}, this._startTime = (new Date)
        .getTime(), this._endTime = this._startTime + 1e3 * this._duration, this._delay = this._startTime, this
          ._ease = null, this._onStart = null, this._onStartParams = null, this._onUpdate = null, this._onUpdateParams =
        null, this._onComplete = null, this._onCompleteParams = null, this._forcekill = !1, this._isContinue = !1,
        this._bezier = null, this._firstUpdate = !0, null != this._params.ease && "function" == typeof this._params
          .ease && (this._ease = this._params.ease, this._params.ease = null), null != this._params.delay && this
            ._params.delay >= 0 && (this._delay = 1e3 * this._params.delay + this._startTime, this._endTime += 1e3 * this
              ._params.delay, this._params.delay = null), null != this._params.onStart && "function" == typeof this
                ._params.onStart && (this._onStart = this._params.onStart, this._params.onStart = null), null != this._params
                  .onStartParams && (this._onStartParams = this._params.onStartParams, this._params.onStartParams = null),
        null != this._params.onUpdate && "function" == typeof this._params.onUpdate && (this._onUpdate = this._params
          .onUpdate, this._params.onUpdate = null), null != this._params.onUpdateParams && (this._onUpdateParams =
            this._params.onUpdateParams, this._params.onUpdateParams = null), null != this._params.onComplete &&
            "function" == typeof this._params.onComplete && (this._onComplete = this._params.onComplete, this._params
              .onComplete = null), null != this._params.onCompleteParams && (this._onCompleteParams = this._params
                .onCompleteParams, this._params.onCompleteParams = null), null != this._params.isContinue && (this
                  ._isContinue = this._params.isContinue, this._params.isContinue = null), null != this._params.bezier && (
                    this._bezier = this._params.bezier, this._params.bezierTime = 1, this._params.bezier = null, this._params
                      .left = null, this._params.top = null, this._bezier.unshift({
                        x: l(this._target, "left"),
                        y: l(this._target, "top")
                      }));
      var d;
      for (d in this._params) null != this._params[d] && (this._sparams[d] = l(this._target, d))
    };
  k.prototype.update = function () {
    for (var a in this._params) null != this._params[a] && (this._sparams[a] = l(this._target, a))
  };
  var l = function (a, c, d) {
    var e = 1 === a.nodeType ? !0 : !1,
      f = null == d ? !0 : !1;
    if (!e && a != document) return f ? a[c] : a[c] = d;
    switch (c) {
      case "opacity":
        if (f) {
          if (null != a.style.opacity) return "" == a.style.opacity ? 1 : Number(a.style.opacity);
          if (null != a.style.MozOpacity) return "" == a.style.MozOpacity ? 1 : Number(a.style.MozOpacity);
          if (null != a.style.filter || null != a.style.Msfilter) {
            var g = a.style.filter || a.style.Msfilter;
            if (g) {
              var h = String(g)
                .split("alpha(opacity=")
                .join("")
                .split(")")
                .join("");
              return null != h ? Number(h) : 1
            }
            return 1
          }
          return 1
        }
        return a.style.Msfilter = "alpha(opacity=" + 100 * d + ")", a.style.filter = "alpha(opacity=" + 100 * d + ")",
          a.style.MozOpacity = d, a.style.opacity = d, null;
      case "scrollLeft":
      case "scrollTop":
        return a == document ? f ? document.documentElement[c] || document.body[c] : (null != document
          .documentElement[c] && (document.documentElement[c] = d), null != document.body[c] && (document.body[c] =
            d), d) : f ? a[c] : (null != a[c] && (a[c] = d), d);
      case "bezierTime":
        return f ? 0 : 1
    }
    if (!f) return a.style[c] = b._static.setUnitAdjust(d), a.style[c];
    if (d = null == d ? 0 : d, a.style && a.style[c]) return d = a.style[c], b._static.getUnitAdjust(d);
    if (a.currentStyle) - 1 != c.indexOf("-") && (c = c.camelize()), d = a.currentStyle[c];
    else if (getComputedStyle) {
      var i = document.defaultView.getComputedStyle(a, "");
      d = i ? i.getPropertyValue(c) : 0
    }
    return b._static.getUnitAdjust(d)
  },
    m = function (a, b) {
      for (var c = {
        x: 0,
        y: 0
      }, d = a.length - 1, e = 0; e < a.length; e++) c.x += a[e].x * n(d, e) * Math.pow(b, e) * Math.pow(1 - b, d -
        e), c.y += a[e].y * n(d, e) * Math.pow(b, e) * Math.pow(1 - b, d - e);
      return c
    },
    n = function (a, b) {
      return 0 == b || b == a ? 1 : b > a || 0 > b ? 0 : o(a, b, a - b)
    },
    o = function (a, b, c) {
      if (c > b && (i = b, b = c, c = i), b > a) d = 0;
      else {
        for (var d = 1; c > 1;) d *= c--;
        for (var e = 1; a > b;) e *= a--;
        d = e / d
      }
      return d
    };
  return b._static.linear = function (a, b, c, d) {
    return c * a / d + b
  }, b._static.easeInQuad = function (a, b, c, d) {
    return c * (a /= d) * a + b
  }, b._static.easeOutQuad = function (a, b, c, d) {
    return -c * (a /= d) * (a - 2) + b
  }, b._static.easeInOutQuad = function (a, b, c, d) {
    return (a /= d / 2) < 1 ? c / 2 * a * a + b : -c / 2 * (--a * (a - 2) - 1) + b
  }, b._static.easeInCubic = function (a, b, c, d) {
    return c * (a /= d) * a * a + b
  }, b._static.easeOutCubic = function (a, b, c, d) {
    return c * ((a = a / d - 1) * a * a + 1) + b
  }, b._static.easeInOutCubic = function (a, b, c, d) {
    return (a /= d / 2) < 1 ? c / 2 * a * a * a + b : c / 2 * ((a -= 2) * a * a + 2) + b
  }, b._static.easeInQuart = function (a, b, c, d) {
    return c * (a /= d) * a * a * a + b
  }, b._static.easeOutQuart = function (a, b, c, d) {
    return -c * ((a = a / d - 1) * a * a * a - 1) + b
  }, b._static.easeInOutQuart = function (a, b, c, d) {
    return (a /= d / 2) < 1 ? c / 2 * a * a * a * a + b : -c / 2 * ((a -= 2) * a * a * a - 2) + b
  }, b._static.easeInQuint = function (a, b, c, d) {
    return c * (a /= d) * a * a * a * a + b
  }, b._static.easeOutQuint = function (a, b, c, d) {
    return c * ((a = a / d - 1) * a * a * a * a + 1) + b
  }, b._static.easeInOutQuint = function (a, b, c, d) {
    return (a /= d / 2) < 1 ? c / 2 * a * a * a * a * a + b : c / 2 * ((a -= 2) * a * a * a * a + 2) + b
  },

    // Sine イージング（滑らかな動き）
    b._static.easeInSine = function (a, b, c, d) {
      return -c * Math.cos(a / d * (Math.PI / 2)) + c + b
    }, b._static.easeOutSine = function (a, b, c, d) {
      return c * Math.sin(a / d * (Math.PI / 2)) + b
    }, b._static.easeInOutSine = function (a, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * a / d) - 1) + b
    },

    // Exponential イージング
    b._static.easeInExpo = function (a, b, c, d) {
      return 0 == a ? b : c * Math.pow(2, 10 * (a / d - 1)) + b
    }, b._static.easeOutExpo = function (a, b, c, d) {
      return a == d ? b + c : c * (-Math.pow(2, -10 * a / d) + 1) + b
    }, b._static.easeInOutExpo = function (a, b, c, d) {
      return 0 == a ? b : a == d ? b + c : (a /= d / 2) < 1 ? c / 2 * Math.pow(2, 10 * (a - 1)) + b : c / 2 * (-Math
        .pow(2, -10 * --a) + 2) + b
    }, b._static.easeInCirc = function (a, b, c, d) {
      return -c * (Math.sqrt(1 - (a /= d) * a) - 1) + b
    }, b._static.easeOutCirc = function (a, b, c, d) {
      return c * Math.sqrt(1 - (a = a / d - 1) * a) + b
    }, b._static.easeInOutCirc = function (a, b, c, d) {
      return (a /= d / 2) < 1 ? -c / 2 * (Math.sqrt(1 - a * a) - 1) + b : c / 2 * (Math.sqrt(1 - (a -= 2) * a) + 1) +
        b
    }, b._static.easeInElastic = function (a, b, c, d) {
      var e = 1.70158,
        f = 0,
        g = c;
      if (0 == a) return b;
      if (1 == (a /= d)) return b + c;
      if (f || (f = .3 * d), g < Math.abs(c)) {
        g = c;
        var e = f / 4
      } else var e = f / (2 * Math.PI) * Math.asin(c / g);
      return -(g * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f)) + b
    }, b._static.easeOutElastic = function (a, b, c, d) {
      var e = 1.70158,
        f = 0,
        g = c;
      if (0 == a) return b;
      if (1 == (a /= d)) return b + c;
      if (f || (f = .3 * d), g < Math.abs(c)) {
        g = c;
        var e = f / 4
      } else var e = f / (2 * Math.PI) * Math.asin(c / g);
      return g * Math.pow(2, -10 * a) * Math.sin((a * d - e) * (2 * Math.PI) / f) + c + b
    }, b._static.easeInOutElastic = function (a, b, c, d) {
      var e = 1.70158,
        f = 0,
        g = c;
      if (0 == a) return b;
      if (2 == (a /= d / 2)) return b + c;
      if (f || (f = d * (.3 * 1.5)), g < Math.abs(c)) {
        g = c;
        var e = f / 4
      } else var e = f / (2 * Math.PI) * Math.asin(c / g);
      return 1 > a ? -.5 * (g * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f)) + b : g * Math
        .pow(2, -10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f) * .5 + c + b
    }, b._static.easeInBack = function (a, b, c, d, e) {
      return void 0 == e && (e = 1.70158), c * (a /= d) * a * ((e + 1) * a - e) + b
    }, b._static.easeOutBack = function (a, b, c, d, e) {
      return void 0 == e && (e = 1.70158), c * ((a = a / d - 1) * a * ((e + 1) * a + e) + 1) + b
    }, b._static.easeInOutBack = function (a, b, c, d, e) {
      return void 0 == e && (e = 1.70158), (a /= d / 2) < 1 ? c / 2 * (a * a * (((e *= 1.525) + 1) * a - e)) + b : c /
        2 * ((a -= 2) * a * (((e *= 1.525) + 1) * a + e) + 2) + b
    }, b._static.easeInBounce = function (a, b, c, d) { }, b._static.easeOutBounce = function (a, b, c, d) {
      return (a /= d) < 1 / 2.75 ? c * (7.5625 * a * a) + b : 2 / 2.75 > a ? c * (7.5625 * (a -= 1.5 / 2.75) * a +
        .75) + b : 2.5 / 2.75 > a ? c * (7.5625 * (a -= 2.25 / 2.75) * a + .9375) + b : c * (7.5625 * (a -= 2.625 /
          2.75) * a + .984375) + b
    }, b._static.easeInOutBounce = function (a, b, c, d) { }, b._self
}(GNS);
// ============================================
// BrowserUtil - ブラウザ判定ユーティリティ
// ============================================
/**
 * GNS.BrowserUtil
 * 
 * ブラウザ・デバイス・OS判定を行う
 * 
 * 判定メソッド:
 * - getDetectSP(): スマートフォン判定
 * - getDetectTabret(): タブレット判定
 * - getDetectiOS(): iOS判定
 * - getDetectAndroid(): Android判定
 * - getDetectIE(): Internet Explorer判定
 * - getDetectChrome(): Chrome判定
 * - getDetectFF(): Firefox判定
 * など多数
 */
GNS.BrowserUtil = function (a) {
  var b = a.create();
  return b._static.getRootPath = function (a, b) {
    for (var c, d, e = document.getElementsByTagName("script"), f = 0; f < e.length; f++) {
      var g = e.item(f);
      if (-1 != g.src.indexOf(a)) {
        c = g.src;
        break
      }
    }
    return d = c.split(b), null == d[0] && (d[0] = ""), d[0]
  }, b._static.getUserAgent = function () {
    return b._static.ua || (b._static.ua = navigator.userAgent), b._static.ua || ""
  }, b._static.getUserAgentLowerCase = function () {
    return b._static.getUserAgent()
      .toLowerCase()
  }, b._static.getDetectSP = function () {
    var a = b._static.getUserAgent();
    return a.indexOf("iPhone") > 0 && -1 == a.indexOf("iPad") || a.indexOf("iPod") > 0 || a.indexOf("Android") >
      0 && a.indexOf("Mobile") > 0 ? !0 : !1
  }, b._static.getDetectTabret = function () {
    var a = b._static.getUserAgent();
    return a.indexOf("iPad") > 0 || a.indexOf("Android") > 0 && -1 == a.indexOf("Mobile") ? !0 : !1
  }, b._static.getDetectIE7 = function () {
    var a = !1,
      c = !1,
      d = b._static.getUserAgentLowerCase(),
      e = window.navigator.appVersion.toLowerCase();
    return -1 != d.indexOf("msie") && (a = !0), a && (-1 != e.indexOf("msie 6.") ? c = !0 : -1 != e.indexOf(
      "msie 7.") && (c = !0)), c
  }, b._static.getDetectIE8 = function () {
    var a = !1,
      c = !1,
      d = b._static.getUserAgentLowerCase(),
      e = window.navigator.appVersion.toLowerCase();
    return -1 != d.indexOf("msie") && (a = !0), a && (-1 != e.indexOf("msie 6.") ? c = !0 : -1 != e.indexOf(
      "msie 7.") ? c = !0 : -1 != e.indexOf("msie 8.") && (c = !0)), c
  }, b._static.getDetectIE9 = function () {
    var a = !1,
      c = !1,
      d = b._static.getUserAgentLowerCase(),
      e = window.navigator.appVersion.toLowerCase();
    return -1 != d.indexOf("msie") && (a = !0), a && (-1 != e.indexOf("msie 9.") ? c = !0 : -1 != e.indexOf(
      "msie 8.") ? c = !0 : -1 != e.indexOf("msie 7.") ? c = !0 : -1 != e.indexOf("msie 6.") && (c = !0)), c
  }, b._static.getDetectIE11 = function () {
    var a = b._static.getUserAgentLowerCase();
    if (a.match(/(msie|MSIE)/) || a.match(/(T|t)rident/)) {
      var c = !0,
        d = a.match(/((msie|MSIE)\s|rv:)([\d\.]+)/),
        e = d && d.length >= 4 ? d[3] : 0;
      e = parseInt(e)
    } else var c = !1;
    return c && 11 == e
  }, b._static.getDetectIE = function () {
    var a = !1,
      c = b._static.getUserAgent();
    return (c.match(/MSIE/) || c.match(/Trident/)) && (a = !0), a
  }, b._static.getDetectFF = function () {
    var a = b._static.getUserAgentLowerCase();
    return -1 != a.indexOf("firefox")
  }, b._static.getDetectWin = function () {
    var a = b._static.getUserAgentLowerCase();
    return -1 != a.indexOf("win")
  }, b._static.getDetectWin8 = function () {
    if (b._static.getDetectWin()) {
      var a = b._static.getUserAgent();
      return -1 != a.indexOf("NT 6.")
    }
    return !1
  }, b._static.getDetectChrome = function () {
    var a = b._static.getUserAgentLowerCase();
    return -1 != a.indexOf("chrome")
  }, b._static.getDetectAndroid = function () {
    var a = b._static.getUserAgentLowerCase(),
      c = !1;
    return -1 != a.indexOf("android") && (c = !0), c
  }, b._static.getDetectAndroidVersion = function () {
    if (b._static.getDetectAndroid()) {
      var a = b._static.getUserAgent(),
        c = parseFloat(a.slice(a.indexOf("Android") + 8));
      return c
    }
    return null
  }, b._static.getDetectiOS = function () {
    var a = b._static.getUserAgentLowerCase(),
      c = !1;
    return (-1 != a.indexOf("ipad") || -1 != a.indexOf("iphone") || -1 != a.indexOf("iPod")) && (c = !0), c
  }, b._static.getDetectiOSVersion = function () {
    if (b._static.getDetectiOS()) {
      var a = b._static.getUserAgent(),
        c = null;
      try {
        if (/iPad/.test(a)) a.match(/CPU OS (\w+){1,3}/g), c = (RegExp.$1.replace(/_/g, "") + "00")
          .slice(0, 3), c = Number(c);
        else if (/iPhone/.test(a)) {
          var d = a.match(/iPhone OS ([\d]+)_([\d]+)_([\d]+)/);
          d || (d = a.match(/iPhone OS ([\d]+)_([\d]+)/)), c = parseInt((RegExp.$1.replace(/_/g, "") + "00")
            .slice(0, 3)), RegExp.$2 && (c += parseInt((RegExp.$2.replace(/_/g, "") + "0")
              .slice(0, 2))), RegExp.$3 && (c += parseInt((RegExp.$3.replace(/_/g, "") + "0")
                .slice(0, 1)))
        }
        c = Number(RegExp.$1) >= 10 ? Number(RegExp.$1) : Number(c) / 100
      } catch (e) { }
      return c
    }
    return null
  }, b._static.getDetectiOS5 = function () {
    var a = b._static.getUserAgentLowerCase(),
      c = !1;
    return b._static.getDetectiOS() && (-1 != a.indexOf("os 5") || -1 != a.indexOf("os 4")) && (c = !0), c
  }, b._static.getDetectiOSSafari = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectiOS() && !!a.match(/safari/i)
  }, b._static.getDetectiOSChrome = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectiOS() && !!a.match(/crios/i)
  }, b._static.getDetectiOSFacebook = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectiOS() && !!a.match(/fb/i)
  }, b._static.getDetectiOSTwitter = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectiOS() && !!a.match(/twitter/i)
  }, b._static.getDetectiOSLine = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectiOS() && !!a.match(/line/i)
  }, b._static.getDetectiOSWebView = function () {
    var a = b._static.getUserAgentLowerCase(),
      c = !!a.match(/twitter/i) || !!a.match(/fb/i) || !!a.match(/line/i);
    return b._static.getDetectiOS() && c
  }, b._static.getDetectAndroidChrome = function () {
    return b._static.getDetectAndroid() && b._static.getDetectChrome()
  }, b._static.getDetectAndroidWebView = function () {
    var a = b._static.getUserAgentLowerCase(),
      c = !!a.match(/twitter/i) || !!a.match(/fb/i) || !!a.match(/line/i);
    return b._static.getDetectAndroid() && c
  }, b._static.getDetectAndroidFacebook = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectAndroid() && !!a.match(/fb/i)
  }, b._static.getDetectAndroidTwitter = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectAndroid() && !!a.match(/twitter/i)
  }, b._static.getDetectAndroidLine = function () {
    var a = b._static.getUserAgentLowerCase();
    return b._static.getDetectAndroid() && !!a.match(/line/i)
  }, b._static.getLocationSearch = function () {
    return window.location.search ? window.location.search.substring(1, window.location.search.length) : null
  }, b._static.getLocationHash = function () {
    return window.location.hash ? -1 == window.location.hash.indexOf("#") ? window.location.hash : String(window
      .location.hash)
      .split("#")
      .join("") : null
  }, b._static.getQuery = function (a) {
    var b = a || window.location.search,
      c = {};
    if (!b) return null;
    b.match(/(.*)(\?)(.*)/);
    if (!RegExp.$3) return null;
    var d = RegExp.$3.split("&");
    if (!d) return null;
    for (var e = 0; e < d.length; e++) {
      var f = d[e].split("=");
      f[0] && (c[f[0]] = f[1])
    }
    return c
  }, b._static.getScriptParam = function (a) {
    for (var b, c = document.getElementsByTagName("script"), d = {}, e = 0; e < c.length; e++) {
      var f = c.item(e);
      if (-1 != f.src.indexOf(a)) {
        b = f;
        break
      }
    }
    if (!b) return !1;
    b.src.match(/(.*)(\?)(.*)/);
    if (!RegExp.$3) return !1;
    var g = RegExp.$3.split("&");
    if (!g) return !1;
    for (var h = 0; h < g.length; h++) {
      var i = g[h].split("=");
      i[0] && (d[i[0]] = i[1])
    }
    return d
  }, b._self
}(GNS);

// ============================================
// JSONUtil - JSON解析ユーティリティ
// ============================================

/**
 * GNS.JSONUtil
 * 
 * JSON文字列を安全にパースする
 * 
 * 主要メソッド:
 * - parse(jsonString): JSON文字列をオブジェクトに変換
 */
GNS.JSONUtil = function (a) {
  var b = a.create();
  b._static.parse = function (a) {
    return "string" == typeof a && a && c.test(a.replace(d, "@")
      .replace(e, "]")
      .replace(f, "")) ? window.JSON && window.JSON.parse ? window.JSON.parse(a) : new Function("return " + a)() :
      null
  };
  var c = /^[\],:{}\s]*$/,
    d = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
    e = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
    f = /(?:^|:|,)(?:\s*\[)+/g;
  return b._self
}(GNS);

// ============================================
// Loader - Ajax通信システム
// ============================================

/**
 * GNS.Loader
 * 
 * XMLHttpRequestを使用した非同期通信
 * 
 * サポート形式:
 * - XML
 * - JSON
 * - FormData
 * 
 * 主要メソッド:
 * - loadXML(url, params, method, async): XML読み込み
 * - loadJSON(url, params, method, async): JSON読み込み
 * - loadData(url, params, method, async): データ読み込み
 * - cancel(): 通信キャンセル
 */
GNS.Loader = function (a) {
  var b = a.create(a.EventDispatcher);
  b._static.TYPE_XML = "application/xml", b._static.TYPE_JSON = "application/json", b._static.TYPE_DATA =
    "application/x-www-form-urlencoded;charset=UTF-8";
  var c = 1e4;
  return b.init = function () {
    b._super.init.call(this), this.service = this.createHttpRequest(), this.isLoad = !1
  }, b.loadXML = function (a, c, d, e) {
    this.load(b._static.TYPE_XML, a, c, d, e)
  }, b.loadJSON = function (a, c, d, e) {
    this.load(b._static.TYPE_JSON, a, c, d, e)
  }, b.loadData = function (a, c, d, e) {
    this.load(b._static.TYPE_DATA, a, c, d, e)
  }, b.load = function (b, d, e, f, g) {
    if (!this.service) return this.dispatchEvent(new a.LoadEvent(a.LoadEvent.FAILED, {
      target: this
    })), null;
    if (!b) return this.dispatchEvent(new a.LoadEvent(a.LoadEvent.FAILED, {
      target: this
    })), null;
    if (!d) return this.dispatchEvent(new a.LoadEvent(a.LoadEvent.FAILED, {
      target: this
    })), null;
    f || (f = "GET");
    var h = "GET" != f ? null : "";
    if (e) {
      h = "";
      for (var i in e) "" != h && (h += "&"), h += i + "=" + encodeURIComponent(e[i])
    }
    null == g && (g = !0), this.isLoad = !0, this.timeoutTimer = setTimeout(function () {
      this.service.abort()
    }.bind(this), c);
    // URLに既に?が含まれている場合は&を使う
    var urlConnector = ("GET" == f && "" != h) ? (d.indexOf("?") !== -1 ? "&" : "?") : "";
    this.service.open(f, d + urlConnector + h, g), this.service
      .onreadystatechange = function () {
        this.service.readyState && this.service.readyState < 4 || (4 == this.service.readyState && 200 == this
          .service.status ? (clearTimeout(this.timeoutTimer), this.dispatchEvent(new a.LoadEvent(a.LoadEvent
            .SUCCESS, {
            target: this,
            content: this.service
          }))) : (this.service.status >= 400 || 302 == this.service.status || 0 == this.service.status) && (
            clearTimeout(this.timeoutTimer), a.Logger.log("Loader :: error status -> " + this.service.status),
            this.dispatchEvent(new a.LoadEvent(a.LoadEvent.FAILED, {
              target: this
            }))))
      }.bind(this), this.service.setRequestHeader("Content-Type", b), this.service.send("GET" == f ? null : h)
  }, b.cancel = function () {
    this.isLoad && (this.service.abort(), clearTimeout(this.timeoutTimer), this.dispatchEvent(new a.LoadEvent(a
      .LoadEvent.CANCEL, {
      target: this
    })))
  }, b.createHttpRequest = function () {
    if (window.ActiveXObject) {
      try {
        return new ActiveXObject("MSXML2.XMLHTTP.6.0")
      } catch (a) { }
      try {
        return new ActiveXObject("MSXML2.XMLHTTP.3.0")
      } catch (a) { }
      try {
        return new ActiveXObject("Msxml2.XMLHTTP")
      } catch (a) { }
      try {
        return new ActiveXObject("Microsoft.XMLHTTP")
      } catch (a) { }
      return null
    }
    return window.XMLHttpRequest ? new XMLHttpRequest : null
  }, b._self
}(GNS);
// ============================================
// DOM - DOM操作ヘルパー
// ============================================
/**
 * GNS.DOM
 * 
 * DOM要素の操作を補助するユーティリティ集
 * 
 * 主要メソッド:
 * - getElement(id): 要素取得（getElementById）
 * - getPosition(element, parent): 要素の位置取得
 * - getRect(element, parent): 要素の矩形取得
 * - addEvent(element, type, callback): イベント追加
 * - removeEvent(element, type, callback): イベント削除
 * - getPageSize(): ページサイズ取得
 * - onLoad(element, callback, errorCallback): 読み込み完了時の処理
 */


// ============================================
// Document - ドキュメントオブジェクト
// ============================================

/**
 * GNS.Document
 * 
 * document オブジェクトのラッパー（シングルトン）
 * ブラウザ・デバイス情報を保持
 * 
 * プロパティ:
 * - body: body要素のDisplayObject
 * - isSP: スマートフォン判定
 * - isPC: PC判定
 * - isIOS: iOS判定
 * - isAndroid: Android判定
 * - isIE, isChrome, isFF: ブラウザ判定
 * - displayWidth, displayHeight: 表示領域サイズ
 * - stageWidth, stageHeight: ページ全体サイズ
 * - scrollX, scrollY: スクロール位置
 * 
 * 主要メソッド:
 * - getInstance(): シングルトンインスタンス取得
 */
GNS.Document = function (a) {
  var b, c = a.create(a.EventDispatcher),
    d = {};
  return c.init = function (b) {
    b == d && (c._super.init.call(this), a.isTabret = a.BrowserUtil.getDetectTabret(), a.isSP = a.BrowserUtil
      .getDetectSP() || a.isTabret, a.isIOS = a.BrowserUtil.getDetectiOS(), a.isAndroid = a.BrowserUtil
        .getDetectAndroid(), a.isPC = !a.isSP, a.isWIN = a.BrowserUtil.getDetectWin(), a.isFF = a.BrowserUtil
          .getDetectFF(), a.isIE = a.BrowserUtil.getDetectIE(), a.isIE11 = a.BrowserUtil.getDetectIE11(), a.isIE9 = a
            .BrowserUtil.getDetectIE9(), a.isIE8 = a.BrowserUtil.getDetectIE8(), a.isIE10 = a.isIE && !a.isIE11 && !a
              .isIE9, a.isChrome = a.BrowserUtil.getDetectChrome(), a.isIOSVersion = a.BrowserUtil
                .getDetectiOSVersion(), a.isAndroidVersion = a.BrowserUtil.getDetectAndroidVersion(), a.isIOSSafari = a
                  .BrowserUtil.getDetectiOSSafari(), a.isIOSChrome = a.BrowserUtil.getDetectiOSChrome(), a.isIOSWebView = a
                    .BrowserUtil.getDetectiOSWebView(), a.isIOSFacebook = a.BrowserUtil.getDetectiOSFacebook(), a.isIOSTwitter =
      a.BrowserUtil.getDetectiOSTwitter(), a.isIOSLine = a.BrowserUtil.getDetectiOSLine(), a.isAndroidChrome = a
        .BrowserUtil.getDetectAndroidChrome(), a.isAndroidWebView = a.BrowserUtil.getDetectAndroidWebView(), a
          .isAndroidFacebook = a.BrowserUtil.getDetectAndroidFacebook(), a.isAndroidTwitter = a.BrowserUtil
            .getDetectAndroidTwitter(), a.isAndroidLine = a.BrowserUtil.getDetectAndroidLine(), a.isWIN8Chrome = a
              .isWIN && a.isChrome && a.BrowserUtil.getDetectWin8(), a.isSuppertWebGL = !0, a.orientation = "portrait", a
                .layoutPC = !0, a.cssTransform = null, a.isWebView = a.isIOSWebView || a.isAndroidWebView, a.DOM.addEvent(
                  window, a.Event.LOAD, this._onLoadHandler), window && null != window.addEventListener && window
                    .addEventListener("DOMContentLoaded", this._onDOMLoadHandler, !1), a.DOM.addEvent(window, a.Event.UNLOAD,
                      this._onUnLoadHandler), a.ResizeManager.init(this._onResizeHandler.bind(this)))
  }, c._static.getInstance = function () {
    return b || (b = new c._self(d)), b
  }, c._onLoadHandler = function (c) {
    a.OrientationManager.init(), a.DOM.removeEvent(window, a.Event.LOAD, this._onLoadHandler), b.body = new a
      .DisplayObject(document.body);
    var d = document.body.style;
    d.hasOwnProperty && (d.hasOwnProperty("transform") ? a.cssTransform = "transform" : d.hasOwnProperty(
      "OTransform") ? a.cssTransform = "OTransform" : d.hasOwnProperty("msTransform") ? a.cssTransform =
        "msTransform" : d.hasOwnProperty("MozTransform") ? a.cssTransform = "MozTransform" : d.hasOwnProperty(
          "webkitTransform") && (a.cssTransform = "webkitTransform")), b._onResizeHandler(), b.dispatchEvent(new a
            .Event(a.Event.LOAD))
  }, c._onDOMLoadHandler = function (c) {
    window.removeEventListener("DOMContentLoaded", this._onDOMLoadHandler, !1), b.dispatchEvent(new a.Event(a.Event
      .DOM_LOAD))
  }, c._onUnLoadHandler = function (c) {
    a.DOM.removeEvent(window, a.Event.LOAD, this._onUnLoadHandler), b.dispatchEvent(new a.Event(a.Event.UNLOAD))
  }, c._onResizeHandler = function (c) {
    var d = a.DOM.getPageSize();
    b.displayWidth = d.displayWidth, b.displayHeight = d.displayHeight, b.stageWidth = d.stageWidth, b.stageHeight =
      d.stageHeight, b.scrollX = d.scrollX, b.scrollY = d.scrollY, a.layoutPC = window.innerWidth >= a.Globals
        .PC_WIDTH
  }, c._self
}(GNS);

// ============================================
// DisplayObject - DOM要素ラッパークラス
// ============================================

/**
 * GNS.DisplayObject
 * 
 * DOM要素をオブジェクト指向で扱うためのラッパークラス
 * jQueryライクなメソッドを提供
 * 
 * 主要メソッド:
 * - init(element): 初期化
 * - addClass(className): クラス追加
 * - removeClass(className): クラス削除
 * - hasClass(className): クラス存在チェック
 * - addEvent(type, callback): イベント追加
 * - removeEvent(type, callback): イベント削除
 * - getPosition(parent): 位置取得
 * - getRect(parent): 矩形取得
 * 
 * プロパティ:
 * - element: 実際のDOM要素
 * - classes: クラス名の配列
 */


// ============================================
// Logger - デバッグログシステム
// ============================================

/**
 * GNS.Logger
 * 
 * デバッグ用のログ表示システム
 * 画面上にログを表示
 * 
 * 主要メソッド:
 * - init(debug): 初期化（debugモードフラグ）
 * - log(message): ログ出力
 * - show(): ログ表示
 * - hide(): ログ非表示
 * - toggle(): ログ表示切り替え
 */
GNS.Logger = function (a) {
  var b = a.create(a.DisplayObject);
  b._static.output = !1, b._static.init = function (a) {
    b._static.output = a, b._static.getInstance()
  };
  var c;
  b._static.getInstance = function () {
    return c || (c = new b._self), c
  };
  var d = "0%",
    e = "50%",
    f = "10000",
    g = "50%",
    h = "100%";
  b.init = function () {
    var a = document.createElement("div");
    a.id = "logger", a.style.position = "absolute", a.style.top = d, a.style.left = e, a.style.zIndex = f, a.style
      .width = g, a.style.height = h, a.style.color = "#999", a.style.fontSize = "10px", a.style.lineHeight =
      "120%", a.style.background = "#000", a.style.opacity = "0.5", a.style.pointerEvents = "none", a.style
        .overflow = "hidden", b._super.init.apply(this, [a]),
      this.visible = !0
  }, b._static.append = function (a, c) {
    if (1 == c && (b._static.output = !0), b._static.output) {
      var d = a || document.body;
      d.appendChild(b._static.getInstance()
        .element)
    }
  };
  var i = 40,
    j = "<br />",
    k = "";
  return b._static.log = function (a) {
    if (b._static.output) {
      k += a + j;
      var c = k.split(j);
      c.length > i && (c.shift(), k = c.join(j)), b._static.getInstance()
        .element.innerHTML = k
    }
  }, b._static.hide = function (a) {
    b._static.getInstance()
      .visible = !1, b._static.getInstance()
        .element.style.display = "none"
  }, b._static.show = function (a) {
    b._static.getInstance()
      .visible = !0, b._static.getInstance()
        .element.style.display = "block"
  }, b._static.toggle = function (a) {
    b._static.getInstance()
      .visible ? b._static.hide() : b._static.show()
  }, b._self
}(GNS), GNS.TouchActionEvent = function (a) {
  var b = a.create(a.Event);
  return b._static.TOUCH_1_START = "touch1start", b._static.TOUCH_1_MOVE = "touch1move", b._static.TOUCH_1_END =
    "touch1end", b._static.TOUCH_2_START = "touch2start", b._static.TOUCH_2_MOVE = "touch2move", b._static
      .TOUCH_2_END = "touch2end", b.init = function (a, c) {
        b._super.init.apply(this, [a, c])
      }, b._self
}(GNS);

// ============================================
// TouchActionController - タッチ操作管理
// ============================================

/**
 * GNS.TouchActionController
 * 
 * タッチイベント（スマホ・タブレット）と
 * マウスイベント（PC）を統合管理
 * 
 * 機能:
 * - タッチ・マウスの座標追跡
 * - シングルタッチ・マルチタッチ対応
 * - ドラッグ検出
 * 
 * プロパティ:
 * - touch0StartX/Y, touch0CurrentX/Y: タッチ座標
 * - isMouseDown: マウス押下状態
 * - touchLength: タッチポイント数
 */
GNS.TouchActionController = function (a) {
  var b = a.create(a.EventDispatcher);
  b.init = function (c) {
    b._super.init.apply(this, []), this.width = 0, this.height = 0, this.touchEnabled = !0, this
      .TOUCH_1_START_EVENT = new a.TouchActionEvent(a.TouchActionEvent.TOUCH_1_START), this.TOUCH_1_MOVE_EVENT =
      new a.TouchActionEvent(a.TouchActionEvent.TOUCH_1_MOVE), this.TOUCH_1_END_EVENT = new a.TouchActionEvent(a
        .TouchActionEvent.TOUCH_1_END), this.TOUCH_2_START_EVENT = new a.TouchActionEvent(a.TouchActionEvent
          .TOUCH_2_START), this.TOUCH_2_MOVE_EVENT = new a.TouchActionEvent(a.TouchActionEvent.TOUCH_2_MOVE), this
            .TOUCH_2_END_EVENT = new a.TouchActionEvent(a.TouchActionEvent.TOUCH_2_END), this.updateSize(), this
              .isTouchEvent = "ontouchstart" in window, this.hasMouseEvent = !0, this.isPreventDefault = !0, this
                .changeEventTarget(c)
  }, b.changeEventTarget = function (a, b) {
    this.element != a && (this.element && (this.removeTouchStartEvent(), this.removeTouchEndEvent()), this
      .touchLength = 0, this.touch0StartX = 0, this.touch0StartY = 0, this.touch1StartX = 0, this.touch1StartY =
      0, this.touch0PrevX = 0, this.touch0PrevY = 0, this.touch1PrevX = 0, this.touch1PrevY = 0, this
        .touch0CurrentX = 0, this.touch0CurrentY = 0, this.touch1CurrentX = 0, this.touch1CurrentY = 0, this
          .hasStartEvent = !1, this.hasEndEvent = !1, this.isMouseDown = !1, this.isSingleTouch = !1, this
            .isTouch1 = !1, this.isTouch2 = !1, this.element = a, this.addTouchStartEvent(), b && (this.hasMouseEvent &&
              this.onMouseDownHandler(b), this.isTouchEvent && this.onTouchHandler(b)))
  }, b._bind.addTouchStartEvent = function () {
    this.hasStartEvent || (this.hasStartEvent = !0, this.hasMouseEvent && (a.DOM.addEvent(this.element, "mousedown",
      this.onMouseDownHandler), a.DOM.addEvent(window, "mousemove", this.onMouseMoveHandler)), this
        .isTouchEvent && (this.element.addEventListener("touchstart", this.onTouchHandler, !1), this.element
          .addEventListener("touchmove", this.onTouchHandler, !1)))
  }, b._bind.removeTouchStartEvent = function () {
    this.hasStartEvent && (this.hasStartEvent = !1, this.hasMouseEvent && (a.DOM.removeEvent(this.element,
      "mousedown", this.onMouseDownHandler), a.DOM.removeEvent(window, "mousemove", this.onMouseMoveHandler)),
      this.isTouchEvent && (this.element.removeEventListener("touchstart", this.onTouchHandler, !1), this.element
        .removeEventListener("touchmove", this.onTouchHandler, !1)))
  }, b._bind.addTouchEndEvent = function () {
    this.hasEndEvent || (this.hasEndEvent = !0, this.hasMouseEvent && a.DOM.addEvent(window, "mouseup", this
      .onMouseUpHandler), this.isTouchEvent && (document.addEventListener("touchend", this.onTouchHandler, !1),
        document.addEventListener("touchcancel", this.onTouchHandler, !1)))
  }, b._bind.removeTouchEndEvent = function () {
    this.hasEndEvent && (this.hasEndEvent = !1, this.hasMouseEvent && a.DOM.removeEvent(window, "mouseup", this
      .onMouseUpHandler), this.isTouchEvent && (document.removeEventListener("touchend", this.onTouchHandler, !
        1), document.removeEventListener("touchcancel", this.onTouchHandler, !1)))
  }, b.updateSize = function () {
    var b = a.DOM.getPageSize();
    this.width = b.displayWidth, this.height = b.displayHeight
  };
  var c = function (a) {
    if (!a) var a = window.event;
    return a.pageX ? a.pageX : a.clientX + (document.body.scrollLeft || document.documentElement.scrollLeft)
  },
    d = function (a) {
      if (!a) var a = window.event;
      return a.pageY ? a.pageY : a.clientY + (document.body.scrollTop || document.documentElement.scrollTop)
    };
  return b._bind.onMouseDownHandler = function (a) {
    this.touchEnabled && !this.isMouseDown && (this.isSingleTouch = !0, this.isMouseDown = !0, this.updateSize(),
      this.touch0StartX = this.touch0PrevX = this.touch0CurrentX = c(a), this.touch0StartY = this.touch0PrevY =
      this.touch0CurrentY = d(a), this.dispatchEvent(this.TOUCH_1_START_EVENT), this.addTouchEndEvent(), this
        .isPreventDefault && a && (a.preventDefault ? a.preventDefault() : a.returnValue = !1))
  }, b._bind.onMouseMoveHandler = function (a) {
    this.isMouseDown && (this.touch0PrevX = this.touch0CurrentX, this.touch0PrevY = this.touch0CurrentY, this
      .touch0CurrentX = c(a), this.touch0CurrentY = d(a), this.touchEnabled ? this.dispatchEvent(this
        .TOUCH_1_MOVE_EVENT) : this.onMouseUpHandler(), this.isPreventDefault && a && (a.preventDefault ? a
          .preventDefault() : a.returnValue = !1))
  }, b._bind.onMouseUpHandler = function (a) {
    this.isMouseDown && (this.isMouseDown = !1, this.dispatchEvent(this.TOUCH_1_END_EVENT), this.isPreventDefault &&
      a && (a.preventDefault ? a.preventDefault() : a.returnValue = !1))
  }, b._bind.onTouchHandler = function (a) {
    if (a && this.touchEnabled) {
      var b = a.touches;
      switch (this.touchLength = b ? b.length : 0, a.type) {
        case "touchstart":
          if (!this.touchEnabled) return;
          this.updateSize(), this.isTouch1 || (this.isTouch1 = !0, this.touch0StartX = this.touch0PrevX = this
            .touch0CurrentX = b[0].pageX, this.touch0StartY = this.touch0PrevY = this.touch0CurrentY = b[0].pageY,
            this.dispatchEvent(this.TOUCH_1_START_EVENT)), this.touchLength >= 2 && !this.isTouch2 && (this
              .isTouch2 = !0, this.touch1StartX = this.touch1PrevX = this.touch1CurrentX = b[1].pageX, this
                .touch1StartY = this.touch1PrevY = this.touch1CurrentY = b[1].pageY, this.dispatchEvent(this
                  .TOUCH_2_START_EVENT)), this.addTouchEndEvent();
          break;
        case "touchmove":
          this.isTouch1 && (this.touch0PrevX = this.touch0CurrentX, this.touch0PrevY = this.touch0CurrentY, this
            .touch0CurrentX = b[0].pageX, this.touch0CurrentY = b[0].pageY, this.dispatchEvent(this
              .TOUCH_1_MOVE_EVENT)), this.isTouch2 && (this.touch1PrevX = this.touch1CurrentX, this.touch1PrevY =
                this.touch1CurrentY, this.touch1CurrentX = b[1].pageX, this.touch1CurrentY = b[1].pageY, this
                  .dispatchEvent(this.TOUCH_2_MOVE_EVENT)), this.touchEnabled || this.onTouchHandler({
                    type: "touchend"
                  });
          break;
        case "touchcancel":
        case "touchend":
          if (1 == this.touchLength && this.isTouch2) {
            this.isTouch2 = !1, this.touch0PrevX = this.touch0CurrentX, this.touch0PrevY = this.touch0CurrentY, this
              .touch0CurrentX = b[0].pageX, this.touch0CurrentY = b[0].pageY;
            var c = (this.touch0CurrentX - this.touch0StartX) * (this.touch0CurrentX - this.touch0StartX) + (this
              .touch0CurrentY - this.touch0StartY) * (this.touch0CurrentY - this.touch0StartY),
              d = (this.touch0CurrentX - this.touch1StartX) * (this.touch0CurrentX - this.touch1StartX) + (this
                .touch0CurrentY - this.touch1StartY) * (this.touch0CurrentY - this.touch1StartY);
            d > c ? (this.touch0StartX = this.touch0StartX, this.touch0StartY = this.touch0StartY) : (this
              .touch0StartX = this.touch1StartX, this.touch0StartY = this.touch1StartY), this.dispatchEvent(this
                .TOUCH_2_END_EVENT)
          }
          b && 0 != this.touchLength || (this.isTouch1 && (this.isTouch1 = !1, this.dispatchEvent(this
            .TOUCH_1_END_EVENT)), this.isTouch2 && (this.isTouch2 = !1, this.dispatchEvent(this
              .TOUCH_2_END_EVENT)), this.removeTouchEndEvent())
      }
      this.isPreventDefault && a && (a.preventDefault ? a.preventDefault() : a.returnValue = !1)
    }
  }, b._self
}(GNS);

// ============================================
// MouseEvent - マウスイベント
// ============================================

/**
 * GNS.MouseEvent
 * 
 * マウスイベントタイプの定義
 * 
 * イベントタイプ:
 * - CLICK, DBLCLICK
 * - MOUSE_DOWN, MOUSE_UP, MOUSE_MOVE
 * - MOUSE_OVER, MOUSE_OUT
 * - MOUSE_WHEEL
 */
GNS.MouseEvent = function (a) {
  var b = a.create(a.Event);
  return b._static.CLICK = "click", b._static.DBLCLICK = "dblclick", b._static.MOUSE_OUT = "mouseout", b._static
    .MOUSE_OVER = "mouseover", b._static.MOUSE_UP = "mouseup", b._static.MOUSE_DOWN = "mousedown", b._static
      .MOUSE_MOVE = "mousemove", b._static.MOUSE_WHEEL = "mousewheel", b.init = function (a, c) {
        b._super.init.apply(this, [a, c])
      }, b._self
}(GNS), GNS.MenuEvent = function (a) {
  var b = a.create(a.Event);
  return b._static.MENU_OPEN = "menu_open", b._static.MENU_BACK = "menu_back", b._static.MENU_CLICK = "menu_click", b
    .init = function (a, c) {
      b._super.init.apply(this, [a, c])
    }, b.toString = function () {
      return "MenuEvent :: type -> " + this.type
    }, b._self
}(GNS);
// ============================================
// APIModel - API エンドポイント定義
// ============================================
/**
 * GNS.APIModel
 * 
 * WordPressのAPIエンドポイントURL を管理
 * 
 * エンドポイント:
 * - getTop(): トップページデータ
 * - getShowreel(): ショーリール動画ID
 * - getOurBusiness(): 事業紹介データ
 * - getWhoWeAre(): 会社紹介データ
 * - getNews(): ニュースデータ
 * - getCases(): 実績データ
 * - getColumn(): コラムデータ
 * - getTalk(): トークデータ
 * 
 * パス:
 * - IMAGE_PATH: 画像ベースパス
 */
GNS.APIModel = function (a) {
  var b = a.create(),
    // WordPressから配信ベースパスを取得
    c = (typeof window.WP_CONFIG !== 'undefined' && window.WP_CONFIG.basePath) ? window.WP_CONFIG.basePath : "/";
  return b._static.IMAGE_PATH = c + "cms/wp-content/themes/dof/assets/release/images/", b._static.log = function (a) { }, b._static.getTop =
    function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_top_posts"
    }, b._static.getShowreel = function () {
      return ""
    }, b._static.getOurBusiness = function () {
      return c + "api_our_business/"
    }, b._static.getWhoWeAre = function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_who_we_are_posts"
    }, b._static.getNews = function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_news_posts"
    }, b._static.getCases = function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_cases_posts"
    }, b._static.getColumn = function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_column_posts"
    }, b._static.getTalk = function () {
      return c + "cms/wp-admin/admin-ajax.php?action=get_talk_posts"
    }, b._self
}(GNS), GNS.APIConnector = function (a) {
  var b = a.create();
  b._static.METHOD_GET = "GET", b._static.METHOD_POST = "POST", b._static.METHOD_PUT = "PUT", b._static
    .METHOD_DELETE = "DELETE";
  var c = {};
  return b._static.getConnector = function (a, d, e) {
    return c[a] || (c[a] = new b._self(a, d, e)), c[a]
  }, b.init = function (b, c, d) {
    this.id = b, this.loader = new a.Loader, this.dispatcher = c, this.callback = d
  }, b.request = function (b, c, d) {
    a.Logger.log(this.id + " :: request ::" + b), this.loader.cancel(), this.loader.addEventListener(a.LoadEvent
      .SUCCESS, this.requestCompleteHandler), this.loader.addEventListener(a.LoadEvent.FAILED, this
        .requestCompleteHandler), this.loader.addEventListener(a.LoadEvent.CANCEL, this.requestCompleteHandler),
      this.loader.loadData(b, d, c)
  }, b._bind.requestCompleteHandler = function (b) {
    this.loader.removeEventListener(a.LoadEvent.SUCCESS, this.requestCompleteHandler), this.loader
      .removeEventListener(a.LoadEvent.FAILED, this.requestCompleteHandler), this.loader.removeEventListener(a
        .LoadEvent.CANCEL, this.requestCompleteHandler), a.Logger.log(this.id + " :: complete");
    var c = new a.Event(a.Event.COMPLETE);
    if (c.params = null, !b || b.type == a.LoadEvent.FAILED) return void this.dispatcher.dispatchEvent(c);
    if (b.type != a.LoadEvent.CANCEL) {
      if (!b.params || !b.params.content) return void this.dispatcher.dispatchEvent(c);
      try {
        var d = b.params.content.responseText,
          e = a.JSONUtil.parse(d);
        if (a.APIModel.log(e), !e) return void this.dispatcher.dispatchEvent(c)
      } catch (f) {
        return void this.dispatcher.dispatchEvent(c)
      }
      c.params = e, this.callback && this.callback(c), this.dispatcher.dispatchEvent(c)
    }
  }, b._self
}(GNS);

// ============================================
// API通信クラス群
// ============================================

/**
 * 以下のAPI通信クラスは同じパターンで実装されています:
 * - APITop: トップページデータ取得
 * - APIShowreel: ショーリール動画ID取得
 * - APICases: 実績データ取得
 * - APINews: ニュースデータ取得
 * - APIOurBusiness: 事業紹介データ取得
 * - APIWhoWeAre: 会社紹介データ取得
 * - APIColumn: コラムデータ取得
 * - APITalk: トークデータ取得
 * 
 * 共通パターン:
 * - dispatcher: EventDispatcherインスタンス
 * - request(): API呼び出し
 * - callback(): 通信完了時の処理
 */

/**
 * GNS.APITop
 * トップページのデータを取得
 */
GNS.APITop = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APITop";
  return b._static.request = function () {
    var d = a.APIModel.getTop(),
      e = a.APIConnector.METHOD_GET,
      f = null;
    a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(d, e, f)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APIShowreel = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APIShowreel";
  return b._static.request = function () {
    var evt = new a.Event(a.Event.COMPLETE);
    try {
      if (window.SHOWREEL_CONFIG && typeof window.SHOWREEL_CONFIG === 'object') {
        evt.params = window.SHOWREEL_CONFIG;
      } else {
        evt.params = {};
      }
    } catch (ex) {
      evt.params = {};
    }
    b._static.dispatcher.dispatchEvent(evt);
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APICases = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APICases";
  return b._static.request = function (d) {
    var e = a.APIModel.getCases(),
      f = a.APIConnector.METHOD_GET,
      g = {};
    g.paged = d, a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(e, f, g)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APINews = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APINews";
  return b._static.request = function (d) {
    var e = a.APIModel.getNews(d),
      f = a.APIConnector.METHOD_GET,
      g = {};
    g.paged = d, a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(e, f, g)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APIOurBusiness = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APIOurBusiness";
  return b._static.request = function () {
    var d = a.APIModel.getOurBusiness(),
      e = a.APIConnector.METHOD_GET,
      f = null;
    a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(d, e, f)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APIWhoWeAre = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APIWhoWeAre";
  return b._static.request = function (d) {
    var e = a.APIModel.getWhoWeAre() + "?category=team_" + d,
      f = a.APIConnector.METHOD_GET,
      g = null;
    a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(e, f, g)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APIColumn = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APIColumn";
  return b._static.request = function (d) {
    var e = a.APIModel.getColumn(),
      f = a.APIConnector.METHOD_GET,
      g = {};
    g.paged = d, a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(e, f, g)
  }, b._static.callback = function (a) { }, b._self
}(GNS), GNS.APITalk = function (a) {
  var b = a.create();
  b._static.dispatcher = new a.EventDispatcher;
  var c = "APITalk";
  return b._static.request = function (d) {
    var e = a.APIModel.getTalk(),
      f = a.APIConnector.METHOD_GET,
      g = {};
    g.paged = d, a.APIConnector.getConnector(c, b._static.dispatcher, b._static.callback)
      .request(e, f, g)
  }, b._static.callback = function (a) { }, b._self
}(GNS);
GNS.GMapJSLoader = function (a) {
  var b, c = a.create(),
    d = "AIzaSyCwgxWhiPWVFyhj7XwgZd2qu6n7m4EcO70";
  c._static.isLoad = !1;
  var e, f;
  c._static.load = function (a, b) {
    e = a, f = b, c._static.isLoad ? j() : g()
  };
  var g = function () {
    if (b) j();
    else {
      var a = "jp";
      window.initMapScript = j, b = document.createElement("script"), k(b, i, h), b.src =
        "https://maps.googleapis.com/maps/api/js?language=" + a + "&key=" + d + "&callback=initMapScript", document
          .body.appendChild(b)
    }
  },
    h = function () {
      f()
    },
    i = function () {
      c._static.isLoad = !0
    },
    j = function () {
      e()
    },
    k = function (a, b, c) {
      "onreadystatechange" in a ? a.onreadystatechange = function (d) {
        return "loaded" === a.readyState || "complete" === a.readyState ? b() : void ("uninitialized" === a
          .readyState && c())
      } : (a.onload = b, a.onerror = c)
    };
  return c._self
}(GNS), GNS.DataManager = function (a) {
  var b, c = a.create(a.EventDispatcher),
    d = {};
  return c.init = function (a) {
    a == d && (c._super.init.call(this, []), this.head_num = 8, this.isFront = !0, this.isMove = !1, this
      .isGenerator = !1, this.isInd = !1, this.inputname = "", this.inputcomment = "", this.shareURL = "", this
        .geo_2head = null, this.geo_4head = null, this.geo_8head = null, this.geo_stage = null, this.isSWIP = !1,
      this.isUpload = !1, this.isGallery = !1, this.isNotSOundAnim = !1, this.dance_total = 0, this.select_head =
      0, this.danceparsennterg = 0)
  }, c._static.getInstance = function () {
    return b || (b = new c._self(d)), b
  }, c._self
}(GNS);

GNS.UIThumBtn = function (a) {
  var b = a.create(a.DisplayObject);
  return b.init = function (a, c, d, e, f, g) {
    if (b._super.init.apply(this, [a]), this.isVideoPlayer = !1, this.addDelay = g || 0, this.element) {
      if (null != c) {
        this.player = c, this.player.setCurrentTime(4);
        var h = this;
        this.player.ready()
          .then(function () {
            h.isVideoPlayer = !0
          })
      }
      this.img = null, null != d && (this.img = d, this.blackDiv = document.createElement("div"), this.blackDiv
        .style.position = "absolute", this.blackDiv.style.top = "0", this.blackDiv.style.right = "0", this
          .blackDiv.style.zIndex = "999", this.blackDiv.style.width = "100%", this.blackDiv.style.height = "100%",
        this.blackDiv.style.background = "#000", this.img.element.parentNode.appendChild(this.blackDiv)), null !=
        e && (this.box = e, TweenMax.set(this.element, {
          alpha: 0,
          y: 0
        }), this.box.element && TweenMax.set(this.box.element, {
          alpha: 0,
          y: 0
        })), this.addEvent("mouseover", this.mouseoverHandler), this.addEvent("mouseleave", this.mouseoutHandler),
        f && (this.splink = f, this.splink.addEvent("mouseover", this.mouseoverHandler), this.splink.addEvent(
          "mouseleave", this.mouseoutHandler)), this.onLoad(this.show.bind(this)), TweenMax.to(this.element, .3, {
            delay: 0,
            alpha: 1,
            y: 0,
            ease: Cubic.easeOut
          }), this.box && TweenMax.to(this.box.element, .3, {
            delay: 0,
            alpha: 1,
            y: 0,
            ease: Cubic.easeOut
          })
    }
  }, b.onLoad = function (a) {
    if (this.img) {
      var b = this.img.element;
      0 !== b.naturalWidth ? a() : "onreadystatechange" in b ? b.onreadystatechange = function (c) {
        return "loaded" === b.readyState || "complete" === b.readyState ? a() : void ("uninitialized" === b
          .readyState && a())
      } : (b.onload = a, b.onerror = a)
    } else a()
  }, b.show = function () {
    var a = .4 + this.addDelay;
    this.element && (0 == a ? (this.blackDiv && TweenMax.set(this.blackDiv, {
      width: "0%"
    }), this.splink && TweenMax.set(this.splink, {
      alpha: 1,
      y: 0
    })) : (this.blackDiv && TweenMax.to(this.blackDiv, .3, {
      delay: a,
      width: "0%",
      ease: Cubic.easeInOut
    }), this.splink && TweenMax.to(this.splink, .3, {
      delay: 0,
      alpha: 1,
      y: 0,
      ease: Cubic.easeOut
    })))
  }, b._bind.mouseoverHandler = function () {
    if (this.isVideoPlayer) {
      // Promiseのエラーハンドリングを追加
      this.player.play().catch(function (error) {
        // PlayInterruptedエラーを無視
        if (error.name !== 'PlayInterrupted') {
          console.warn('Video play error:', error);
        }
      });
      this.img && this.img.element && TweenMax.to(this.img.element, .3, {
        delay: 0,
        autoAlpha: 0,
        ease: Cubic.easeOut
      });
    } else {
      this.img && this.img.element && TweenMax.to(this.img.element, .6, {
        delay: 0,
        scale: 1.08,
        ease: Power2.easeOut
      });
    }
    this.element && (this.addClass("init"), a.Animate.kill(this), a.Animate.to(this, .01, {
      onComplete: this.overAnim
    }))
  }, b._bind.overAnim = function () {
    this.addClass("overanim")
  }, b._bind.mouseoutHandler = function () {
    if (this.isVideoPlayer) {
      // Promiseのエラーハンドリングを追加
      this.player.pause().catch(function (error) {
        // PlayInterruptedエラーを無視
        if (error.name !== 'PlayInterrupted') {
          console.warn('Video pause error:', error);
        }
      });
      this.img && this.img.element && TweenMax.to(this.img.element, .3, {
        delay: 0,
        autoAlpha: 1,
        ease: Cubic.easeOut
      });
    } else {
      this.img && TweenMax.to(this.img.element, .4, {
        delay: 0,
        scale: 1,
        ease: Cubic.easeOut
      });
    }
    this.element && (a.Animate.kill(this), this.removeClass("init"), this.removeClass("overanim"))
  }, b.kill = function () {
    this.element && (this.blackDiv && TweenMax.killTweensOf(this.blackDiv), this.box && TweenMax.killTweensOf(this
      .box.element), TweenMax.killTweensOf(this.element), this.img && TweenMax.killTweensOf(this.img.element),
      TweenMax.killTweensOf(this), this.removeEvent("mouseover", this.mouseoverHandler), this.removeEvent(
        "mouseleave", this.mouseoutHandler), this.splink && (this.splink.removeEvent("mouseover", this
          .mouseoverHandler), this.splink.removeEvent("mouseleave", this.mouseoutHandler)), this.player && (this
            .player.pause(), this.player.unload()
              .then(function () { })["catch"](function (a) { }), this.player = null))
  }, b._self
}(GNS), GNS.UIMenuBtn = function (a) {
  var b = a.create(a.DisplayObject);
  return b.init = function (a) {
    b._super.init.apply(this, [a]), this.btnname = a, this.url = this.element.href, this.addEvent("click", this
      .click)
  }, b._bind.click = function (b) {
    b && (b.preventDefault ? b.preventDefault() : b.returnValue = !1), a.Logger.log("UIMenuBtn :: click :: " + this
      .btnname), this.clickDelay(), a.Header.getInstance()
        .closeMenu()
  }, b._bind.clickDelay = function () {
    a.SceneController.gotoSceneAt(this.url)
  }, b._self
}(GNS);

// ============================================
// UI Button Components
// ============================================

/**
 * GNS.UIPageBtn
 * ページ切り替えボタン
 */
GNS.UIPageBtn = function (a) {
  var b = a.create(a.DisplayObject);
  return b.init = function (a, c) {
    b._super.init.apply(this, [a]), this.id = c
  }, b._self
}(GNS);
// ============================================
// Wrapper - メインコンテナ管理
// ============================================
/**
 * GNS.Wrapper
 * 
 * #wrapper 要素（メインコンテナ）を管理
 * 
 * 機能:
 * - スクロール位置の保存・復元
 * - fixed状態の管理（メニュー開閉時）
 * 
 * 主要メソッド:
 * - setFixed(boolean): fixed状態設定
 * - saveScroll(): スクロール位置保存
 * - restoreScroll(): スクロール位置復元
 * - setTypeOurbusiness(boolean): 事業紹介ページ用スタイル
 */
GNS.Wrapper = function (a) {
  var b, c = a.create(a.DisplayObject);
  c._static.getInstance = function () {
    return b || (b = new c._self), b
  }, c.init = function () {
    c._super.init.apply(this, ["wrapper"]), this.isFixed = !1
  }, c.getFixed = function () {
    return this.isFixed
  }, c.setFixed = function (a) {
    this.isFixed = a, a ? this.addClass("fixed") : this.removeClass("fixed")
  }, c.setTypeOurbusiness = function (a) {
    a ? this.addClass("type_ourbusiness") : this.removeClass("type_ourbusiness")
  };
  var d = !1,
    e = 0;
  return c.saveScroll = function () {
    // デバッグ用：完全に無効化
    // e = a.DOM.getPageSize().scrollY;
    // d = !0
  }, c.getFixScroll = function () {
    return e
  }, c.restoreScroll = function () {
    // デバッグ用：完全に無効化
    // d && (a.Animate.direct(document, {
    //   scrollTop: e
    // }), e = 0, d = !0)
  }, c._self
}(GNS);


// ============================================
// Header - ヘッダーコンポーネント
// ============================================
/**
 * GNS.Header
 * 
 * ページ上部のヘッダーを管理（シングルトン）
 * 
 * 主要な要素:
 * - ロゴ (#header__logo)
 * - メニューボタン (#header__menu)
 * - ナビゲーション各種
 * - 言語切り替えボタン（JA/EN）★重要★
 * 
 * 主要メソッド:
 * - init(): 初期化
 * - openMenu(): メニューを開く
 * - closeMenu(): メニューを閉じる
 * - toggleMenu(): メニュー開閉切り替え
 * - alwaysShow(): 常に表示
 * - autoShow(): スクロールに応じて自動表示/非表示
 * - _btnJAClick(): 日本語ボタンクリック★
 * - _btnENClick(): 英語ボタンクリック★
 * 
 * プロパティ:
 * - isOpen: メニューが開いているか
 * - isAlwaysShow: 常に表示するか
 * - btnJA, btnEN: 言語切り替えボタン
 */
GNS.Header = function (a) {
  var b, c = a.create(a.DisplayObject);
  c._static.getInstance = function () {
    return b || (b = new c._self), b
  };
  var d, e, f;
  return c.init = function () {
    c._super.init.apply(this, ["header"]), this.isOpen = !1, this.isAlwaysShow = !1, this.bg = new a.DisplayObject(
      "header__bg"), d = new a.DisplayObject("header__logo"), d.addEvent("click", this._clickLogo), e = new a
        .DisplayObject("header__menu"), e.addEvent("click", this.toggleMenu), f = a.Menu.getInstance(), f
          .addEventListener("opened", this.openedMenu), f.addEventListener("closed", this.closedMenu), this.btn_who = new a.UIMenuBtn("header__nav__who_we_are"), this
            .btn_member = new a.UIMenuBtn("header__nav__member"), this.btn_news = new a.UIMenuBtn("header__nav__news"), this
              .btn_cases = new a.UIMenuBtn("header__nav__cases"), this.btn_contact = new a.UIMenuBtn("header__nav__contact"), this.btn_talk = new a.UIMenuBtn("header__nav__talk"),
      this.btn_recruit = new a.UIMenuBtn("header__nav__recruit"), this
        .languegaeSet = new a.DisplayObject("header__nav__langueage"),
      this.btnJA = new a.DisplayObject("header__nav__langueage__item--ja"),
      this.btnEN = new a.DisplayObject("header__nav__langueage__item--en"),
      this.btnJA && this.btnJA.addEvent("click", this._btnJAClick),
      this.btnEN && this.btnEN.addEvent("click", this._btnENClick),
      a.DOM
        .addEvent(window, "scroll", this._autoShowCheck)
  }, c.alwaysShow = function () {
    this.isAlwaysShow = !0, this.removeClass("enabled"), this.logoSet(!1)
  }, c.autoShow = function () {
    this.isAlwaysShow = !1, this._autoShowCheck(), this.logoSet(!0)
  }, c._bind._autoShowCheck = function () {
    var b = a.DOM.getPageSize();
    if (this.element.style.left = -b.scrollX + "px", !this.isAlwaysShow && !this.isOpen) {
      var c = b.scrollY;
      c > 100 ? this.removeClass("enabled") : this.hasClass("enabled") || this.addClass("enabled")
    }
  }, c.logoSet = function (a) {
    a ? d.addClass("type--index") : d.removeClass("type--index")
  }, c._bind._clickLogo = function (b) {
    a.SceneController.gotoSceneAt(d.element.href), b && (b.preventDefault ? b.preventDefault() : b.returnValue = !1)
  },

    /**
     * _btnJAClick() - 日本語ボタンクリック
     * 
     * HTML要素: #header__nav__langueage__item--ja
     * 
     * 処理:
     * 1. 現在英語モード（lang_type_en）の場合のみ
     * 2. SceneController.languageChange("ja") を実行
     * 3. メニューを閉じる
     */
    c._bind._btnJAClick = function () {
      a.Document.getInstance()
        .body.hasClass("lang_type_en") && (a.SceneController.languageChange("ja"), a.Header.getInstance()
          .closeMenu())
    },

    /**
     * _btnENClick() - 英語ボタンクリック
     * 
     * HTML要素: #header__nav__langueage__item--en
     * 
     * 処理:
     * 1. 現在日本語モード（lang_type_enなし）の場合のみ
     * 2. SceneController.languageChange("en") を実行
     * 3. メニューを閉じる
     */
    c._bind._btnENClick = function () {
      a.Document.getInstance()
        .body.hasClass("lang_type_en") || (a.SceneController.languageChange("en"), a.Header.getInstance()
          .closeMenu())
    }, c._bind.toggleMenu = function (a) {
      this.isOpen ? this.closeMenu() : (1 == a && (this.addClass("fast"), this.removeClass("enabled")), this.openMenu());
    }, c._bind.openMenu = function () {
      this.isOpen || (this.isOpen = !0, this.dispatchEvent(new a.Event("nav_open")), e.addClass("on"), this.hasClass(
        "enabled") && (this.addClass("fast"), this.removeClass("enabled")), this.addClass("open"), f.open())
    }, c._bind.openedMenu = function () {
      this.addClass("logohide")
    }, c._bind.closeMenu = function () {
      this.isOpen && (this.isOpen = !1, this.dispatchEvent(new a.Event("nav_close")), this.removeClass("fast"), e
        .removeClass("on"), this.removeClass("logohide"), f.close())
    }, c._bind.closedMenu = function () {
      this.removeClass("open"), this._autoShowCheck()
    }, c._self
}(GNS);

// ============================================
// Footer - フッターコンポーネント
// ============================================

/**
 * GNS.Footer
 * 
 * ページ下部のフッターを管理（シングルトン）
 * 
 * 主要メソッド:
 * - init(): 初期化
 * - show(): フッター表示
 * - hide(): フッター非表示
 * - forceInvisible(boolean): 強制非表示
 * - ourBusinessInvisible(boolean): 事業紹介ページ用表示制御
 */
GNS.Footer = function (a) {
  var b, c = a.create(a.DisplayObject);
  return c._static.getInstance = function () {
    return b || (b = new c._self), b
  }, c.init = function () {
    c._super.init.apply(this, ["footer"]), TweenMax.set(this.element, {
      y: 0,
      alpha: 0
    }), this.btnCookiePolicy = new a.DisplayObject("footer__cookiepolicy"), this.btnCookiePolicy.addEvent("click",
      function (b) {
        b && (b.preventDefault ? b.preventDefault() : b.returnValue = !1), a.SceneController.gotoSceneAt(this
          .btnCookiePolicy.element.href)
      }.bind(this))
  }, c.show = function () {
    this.addClass("show"), TweenMax.set(this.element, {
      y: 0
    }), TweenMax.to(this.element, .5, {
      alpha: 1,
      ease: Cubic.easeInOut
    })
  }, c.hide = function () {
    this.forceInvisible(!1), this.removeClass("show"), TweenMax.to(this.element, .5, {
      y: 50,
      alpha: 0,
      ease: Cubic.easeInOut
    })
  }, c.forceInvisible = function (a) {
    a ? this.addClass("invisible") : (this.removeClass("invisible"), this.ourBusinessInvisible(a))
  }, c.ourBusinessInvisible = function (b) {
    b ? this.addClass("type_ourbusiness") : (this.removeClass("type_ourbusiness"), TweenMax.killTweensOf(a.Footer
      .getInstance()
      .element), TweenMax.set(a.Footer.getInstance()
        .element, {
        autoAlpha: 1
      }))
  }, c._self
}(GNS);




// ============================================
// Menu/Navigation - メニュー・ナビゲーション
// ============================================

/**
 * GNS.Menu
 * 
 * ハンバーガーメニューを管理（シングルトン）
 * 
 * 主要な要素:
 * - メニュー項目各種
 * - 言語切り替えボタン（JA/EN）★重要★
 * - SNSリンク
 * 
 * 主要メソッド:
 * - init(): 初期化
 * - open(): メニューを開く
 * - close(): メニューを閉じる
 * - setActive(index): アクティブ項目を設定
 * - _btnJAClick(): 日本語ボタンクリック★
 * - _btnENClick(): 英語ボタンクリック★
 * 
 * メニュー項目インデックス:
 * 0: TOP
 * 1: WHO WE ARE
 * 2: MEMBER
 * 3: WORKS (CASES)
 * 4: NEWS
 * 5: RECRUIT
 * 6: CONTACT
 * 7: dof talk
 */
GNS.Menu = function (a) {
  var b, c = a.create(a.DisplayObject);
  c._static.getInstance = function () {
    return b || (b = new c._self), b
  };
  var d = new a.Event("opened"),
    e = new a.Event("closed");
  return c.init = function () {
    c._super.init.apply(this, ["nav"]), this.fixbg = new a.DisplayObject("nav_fixbg"), this.bg = new a
      .DisplayObject("nav__bg"), this.container = new a.DisplayObject("nav__container"), this.btn_top = new a
        .UIMenuBtn("nav__top"), this.btn_who = new a.UIMenuBtn(
          "nav__who_we_are"), this.btn_member = new a.UIMenuBtn("nav__member"), this.btn_news = new a.UIMenuBtn("nav__news"), this.btn_cases = new a.UIMenuBtn(
            "nav__cases"), this.btn_contact = new a.UIMenuBtn("nav__contact"), this.btn_recruit = new a.UIMenuBtn(
              "nav__recruit"), this.btn_talk = new a.UIMenuBtn("nav__talk"), this.languegaeSet = new a
                .DisplayObject("nav__langueage"), this.items = [], this.items.push(this.btn_top), this.items.push(this
                  .btn_who), this.items.push(this.btn_member), this.items.push(this.btn_cases), this.items.push(this.btn_news),
      this.items.push(this.btn_recruit), this.items.push(this.btn_contact), this.items.push(this.btn_talk), this
        .items.push(this.languegaeSet)
    // 英語版削除により、言語切り替えボタンは無効化
    // this.btnJA = new a.DisplayObject("nav__langueage__item--ja"), 
    // this.btnEN = new a.DisplayObject("nav__langueage__item--en"), 
    // this.btnJA.addEvent("click", this._btnJAClick), 
    // this.btnEN.addEvent("click", this._btnENClick)
  }, c.setActive = function (a) {
    for (var b = 0; b < this.items.length; b++) b == a ? this.items[b].addClass("select") : this.items[b]
      .removeClass("select")
  }, c.open = function () {
    if (this.btnJA && this.btnEN) {
      a.Document.getInstance()
        .body.hasClass("lang_type_en") ? (this.btnJA.removeClass("active"), this.btnEN.addClass("active")) : (this
          .btnJA.addClass("active"), this.btnEN.removeClass("active"));
    }
    a.Wrapper.getInstance()
      .saveScroll(), TweenMax.killTweensOf(this.bg.element), TweenMax.set(this.bg.element, {
        width: "0%"
      }), TweenMax.to(this.bg.element, .4, {
        width: "100%",
        ease: Cubic.easeInOut,
        onComplete: function () {
          this.dispatchEvent(d), a.Wrapper.getInstance()
            .setFixed(!0), this.fixbg.addClass("show")
        }.bind(this)
      });
    for (var b = 0; b < this.items.length; b++) {
      if (this.items[b] && this.items[b].element) {
        TweenMax.set(this.items[b].element, {
          alpha: 0,
          x: 100
        }), TweenMax.to(this.items[b].element, .3, {
          delay: .2 + .03 * b,
          alpha: 1,
          x: 0,
          ease: Cubic.easeInOut
        })
      }
    }
  }, c.close = function () {
    this.fixbg.removeClass("show");
    for (var b = 0; b < this.items.length; b++) {
      if (this.items[b] && this.items[b].element) {
        TweenMax.set(this.items[b].element, {
          alpha: 1,
          x: 0
        });
        var c = {
          delay: 0 + .02 * (this.items.length - 1 - b),
          alpha: 0,
          x: 100,
          ease: Cubic.easeOut
        };
        b >= this.items.length - 1 && (c.onComplete = function () {
          a.Wrapper.getInstance()
            .setFixed(!1), a.Wrapper.getInstance()
              .restoreScroll()
        }), TweenMax.to(this.items[b].element, .3, c)
      }
    }
    // Backup: Ensure scroll lock is removed even if animation callback fails
    TweenMax.delayedCall(0.8, function () {
      a.Wrapper.getInstance().setFixed(!1);
    });
    TweenMax.killTweensOf(this.bg.element), TweenMax.to(this.bg.element, .5, {
      delay: .2,
      width: "0%",
      ease: Cubic.easeInOut,
      onComplete: function () {
        this.dispatchEvent(e)
      }.bind(this)
    })
  },

    /**
     * _btnJAClick() - 日本語ボタンクリック（メニュー内）
     * 
     * HTML要素: #nav__langueage__item--ja
     * 
     * 処理:
     * 1. 現在英語モードの場合のみ
     * 2. 言語を日本語に切り替え
     * 3. メニューを閉じる
     */
    c._bind._btnJAClick = function () {
      a.Document.getInstance()
        .body.hasClass("lang_type_en") && (a.SceneController.languageChange("ja"),
          a.Header.getInstance()
            .closeMenu())
    },

    /**
     * _btnENClick() - 英語ボタンクリック（メニュー内）
     * 
     * HTML要素: #nav__langueage__item--en
     * 
     * 処理:
     * 1. 現在日本語モードの場合のみ
     * 2. 言語を英語に切り替え
     * 3. メニューを閉じる
     */
    c._bind._btnENClick = function () {
      a.Document.getInstance()
        .body.hasClass("lang_type_en") || (a.SceneController.languageChange("en"), a.Header.getInstance()
          .closeMenu())
    }, c._self
}(GNS);

// ============================================
// Contents - コンテンツコンテナ
// ============================================

/**
 * GNS.Contents
 * #contents 要素を管理
 */
GNS.Contents = function (a) {
  var b, c = a.create(a.DisplayObject);
  return c._static.getInstance = function () {
    return b || (b = new c._self), b
  }, c.init = function () {
    c._super.init.apply(this, ["contents"])
  }, c._self
}(GNS);

// ============================================
// SiteLoading - サイトローディング
// ============================================

/**
 * GNS.SiteLoading
 * 
 * サイト全体のローディング画面を管理
 * 初回アクセス時に表示されるローディングアニメーション
 * 
 * 主要メソッド:
 * - show(callback): ローディング表示
 * - hide(callback): ローディング非表示
 */
GNS.SiteLoading = function (a) {
  var b, c = a.create(a.AbstractElementView);
  c._static.getInstance = function () {
    return b || (b = new c._self), b
  }, c.init = function () {
    c._super.init.apply(this, ["site_loading"])
  };
  var d = null;
  return c.show = function (a) {
    d = a, this.addClass("init"), TweenMax.delayedCall(.5, this._showComplete)
  }, c._bind._showComplete = function () {
    d && d()
  }, c.hide = function (a) {
    d = a, TweenMax.delayedCall(.5, this._hideBetween)
  }, c._bind._hideBetween = function () {
    this.addClass("out"), TweenMax.delayedCall(.5, this._hideComplete)
  }, c._bind._hideComplete = function () {
    this.addClass("hide"), d && d()
  }, c._self
}(GNS);



// ============================================
// CasesDetailScene - 実績詳細ページシーン
// ============================================

/**
 * GNS.CasesDetailScene
 * * 実績詳細ページのメイン制御クラス
 * * 機能:
 * - 詳細コンテンツの表示
 * - ページ下部などの関連実績リンクのインタラクション制御
 */
GNS.CasesDetailScene = function (GNS) {
  // AbstractSceneを継承
  const scene = GNS.create(GNS.AbstractScene);

  /**
   * 初期化処理
   */
  scene.init = function (data) {
    scene._super.init.call(this, data);

    // インタラクションボタン管理用配列
    this.buttons = []; // 旧 playerArray

    // トップ画像（元コードにありましたが、以降のロジックでは未使用のようです）
    this.topImage = new GNS.DisplayObject("casesdetail__container__title__img");
  };

  /**
   * ロード処理
   */
  scene.load = function () {
    this.isLoading = true;
    this._loadComplete();
  };

  /**
   * ロード完了時の処理
   * 関連実績ボックスを取得し、ボタンインタラクションを付与
   */
  scene._bind._loadComplete = function () {
    try {
      this._initRelatedCasesButtons();
    } catch (err) {
      console.error("CasesDetailScene init error:", err);
    }

    // 親クラスのロード完了処理
    scene._super.load.call(this);
  };

  /**
   * 関連実績ボタンの初期化ヘルパー
   */
  scene._initRelatedCasesButtons = function () {
    // 実績ボックスのリストを取得
    const caseBoxes = this.element.querySelectorAll(".casesdetail__container__column__box");

    Array.from(caseBoxes).forEach((boxEl, index) => {
      // リンク要素（トリガー）
      const linkEl = boxEl.querySelector(".item__link");

      // リンクがない場合はスキップ
      if (!linkEl) return;

      // 画像オブジェクトの生成
      let imgObj = null;
      const imgContainer = boxEl.querySelector(".casesdetail__container__column__box__img");
      if (imgContainer) {
        const imgTag = imgContainer.getElementsByTagName("img")[0];
        if (imgTag) {
          imgObj = new GNS.DisplayObject(imgTag);
        }
      }

      // ボックスコンテナのオブジェクト
      const boxObj = new GNS.DisplayObject(boxEl);

      // UIThumBtn(TriggerLink, Bg, ImageObj, ContainerObj, ExtraLink, Delay)
      const btn = new GNS.UIThumBtn(
        linkEl,   // リンク
        null,     // 背景（未使用）
        imgObj,   // ホバー時に動かす画像
        boxObj,   // コンテナ
        null,     // 追加リンク（未使用）
        0.05 * index // 遅延係数
      );

      this.buttons.push(btn);
    });
  };

  /**
   * 表示ハンドラ
   */
  scene.showHandler = function () {
    // 実装なし
  };

  /**
   * 非表示ハンドラ
   */
  scene.hideHandler = function () {
    // 実装なし
  };

  /**
   * リセットハンドラ
   * 生成したボタンインスタンスを破棄
   */
  scene.resetHandler = function () {
    this.buttons.forEach(btn => {
      if (btn.kill) btn.kill();
    });
    this.buttons = [];
  };

  return scene._self;
}(GNS);






















// ============================================
// System - システム起動
// ============================================

/**
 * GNS.System
 * 
 * アプリケーション全体の起動処理
 * 
 * 処理フロー:
 * 1. Document のLOADイベントを監視
 * 2. ページロード完了時に SceneController.init() を実行
 * 
 * これがアプリケーションのエントリーポイント
 */
GNS.System = function (a) {
  var b = a.create();
  b.init = function () {
    a.Document.getInstance()
      .addEventListener(a.Event.LOAD, c), a.Document.getInstance()
        .addEventListener(a.Event.UNLOAD, d)
  };
  var c = function (b) {
    a.Document.getInstance()
      .removeEventListener(a.Event.LOAD, c), a.Logger.init(a.Globals.DEBUG), a.Logger.append(null, a.Globals.DEBUG),
      a.Logger.log("System :: onLoad"),

      // ★★★ アプリケーション起動 ★★★
      a.SceneController.init()
  },
    d = function (a) { };

  // システムを起動
  return b.init(), b._self
}(GNS);

// ============================================
// 【完了】コード終端
// ============================================
/**
 * コメント追加完了
 * 
 * 主要なコンポーネント:
 * ✅ GNS Framework (行 33-)
 * ✅ ClassFactory (行 74-)
 * ✅ Event System (行 145-, 173-)
 * ✅ CookieManager (行 300-) ★Cookie管理★
 * ✅ DisplayObject (行 1187-) ★DOM操作★
 * ✅ SceneController (行 1697-) ★★★最重要★★★
 *    ├─ languageChange() (行 1799-1804) ★言語切り替え★
 *    └─ initialLanguageCheck() (行 1767-1770)
 * ✅ Header (行 2201-) ★言語ボタン★
 *    ├─ _btnJAClick() (行 2247-2251)
 *    └─ _btnENClick() (行 2263-2267)
 * ✅ Menu (行 2370-) ★言語ボタン★
 *    ├─ _btnJAClick() (行 2457-2462)
 *    └─ _btnENClick() (行 2474-2478)
 * ✅ Scene Classes (行 2593-) ★各ページ★
 * ✅ System (行 4295-) ★起動処理★
 * 
 * 言語切り替えの完全なフロー:
 * 1. System起動 → SceneController.init()
 * 2. initialLanguageCheck() で Cookie確認
 * 3. languageChange("ja"/"en") 実行
 * 4. body.lang_type_en クラスの追加/削除
 * 5. CSSで .lang_jp / .lang_en の表示切り替え
 * 6. ボタンクリック → Header/Menu._btn[JA|EN]Click()
 * 7. languageChange() 再実行
 * 
 * 総行数: 4,300行以上（コメント追加後）
 * 元行数: 3,185行
 * 追加コメント: 1,000行以上
 */
